/**
 * ScorecardCustomizeOperations - Alpine.js Data Component
 * Manages customize mode operations: editing names and drag-and-drop sorting
 * 
 * All functionality is namespaced under 'cz_' to avoid key collisions
 * with parent components.
 */
export default () => ({
    /**
     * Update section name
     */
    cz_updateSectionName(section, newName) {
        newName = newName?.trim() || '';
        if (!newName || newName.length === 0) {
            newName = 'Untitled section';
        }
        
        const scorecardSections = this.fullScorecardData?.sections || [];
        const sectionIndex = scorecardSections.findIndex(s => s.id === section.id);
        if (sectionIndex !== -1) {
            scorecardSections[sectionIndex].name = newName;
            this.fullScorecardData.sections = scorecardSections;
            
            this.updateFilteredSections();
            this.$wire.updateSectionName(section.id, newName);
        }
    },
    
    /**
     * Update row display name
     */
    cz_updateRowName(row, newName) {
        newName = newName?.trim() || '';
        if (!newName || newName.length === 0) {
            newName = row.metric?.name || row.display_name;
        }

        const scorecard_rows = this.fullScorecardData?.rows || [];
        const rowIndex = scorecard_rows.findIndex(s => s.id === row.id);
        
        if (rowIndex !== -1) {
            scorecard_rows[rowIndex].display_name = newName;
            this.fullScorecardData.rows = scorecard_rows;
            
            this.updateFilteredSections();
            this.$wire.updateRowName(row.id, newName);
        }
    },

    /**
     * Handle section drag-and-drop sorting
     */
    cz_handleSectionSort(item, position) {
        const scorecard_sections = this.fullScorecardData?.sections || [];
        const newOrder = {};
        let index = 0;
        
        const sectionElements = this.$refs.leftContentCustomize.querySelectorAll('[x-sort\\:item]');
        
        sectionElements.forEach((element) => {
            const sectionId = element.dataset.sectionid;
            if (sectionId === 'GHOST') return;
            
            const section = scorecard_sections.find(s => String(s.id) === sectionId);
            
            if (section && section.id) {
                newOrder[section.id] = index;
                index++;
            }
        });
        
        if (Object.keys(newOrder).length > 0) {
            Object.entries(newOrder).forEach(([sectionId, order]) => {
                const sectionIndex = scorecard_sections.findIndex(s => String(s.id) === sectionId);
                if (sectionIndex !== -1) {
                    scorecard_sections[sectionIndex].order = order;
                }
            });
            
            this.fullScorecardData = {
                ...this.fullScorecardData,
                sections: [...scorecard_sections]
            };
            
            this.sortKey++;
            this.updateFilteredSections();
            
            this.$wire.call('updateScorecardSectionsOrder', newOrder).catch((error) => {
                console.error('Error saving section order:', error);
            });
        }
    },

    /**
     * Handle row drag-and-drop sorting (within and between sections)
     */
    cz_handleRowSort(sectionId, rowID, position) {
        const allRowData = [];
        const sectionsWithNewRows = new Set();
        const scorecard_rows = this.fullScorecardData?.rows || [];

        this.$refs.leftContentCustomize.querySelectorAll(`[x-sort\\:group='scorecard-rows']`).forEach((sectionContainer) => {
            const sectionElement = sectionContainer.closest('[x-sort\\:item]');
            
            if (!sectionElement) return;
            
            const currentSectionId = sectionElement.dataset.sectionid;
            const rowElements = sectionContainer.querySelectorAll('[x-sort\\:item]');
            
            if (rowElements.length > 0) {
                sectionsWithNewRows.add(currentSectionId);
            }
            
            rowElements.forEach((rowElement, index) => {
                const rowId = rowElement.dataset.rowid;
                const rowData = scorecard_rows.find(r => String(r.id) === rowId);
                
                if (rowData && rowData.id) {
                    allRowData.push({
                        rowId: rowData.id,
                        sectionId: currentSectionId,
                        order: index
                    });
                }
            });
        });
        
        sectionsWithNewRows.forEach(sId => {
            if (sId === 'GHOST') return;
            const scorecard_sections = this.fullScorecardData?.sections || [];
            const section = scorecard_sections.find(s => String(s.id) === sId);
            if (section && !section.expanded) {
                section.expanded = true;
                this.fullScorecardData.sections = scorecard_sections;
            }
        });
        
        if (allRowData.length > 0) {
            allRowData.forEach(row => {
                const rowIndex = scorecard_rows.findIndex(r => r.id === row.rowId);
                if (rowIndex !== -1) {
                    scorecard_rows[rowIndex].scorecard_section_id = row.sectionId === 'GHOST' ? null : row.sectionId;
                    scorecard_rows[rowIndex].order = row.order;
                }
            });

            this.fullScorecardData = {
                ...this.fullScorecardData,
                rows: [...scorecard_rows]
            };
            
            this.sortKey++;
            this.updateFilteredSections();
            
            this.$wire.call('updateScorecardRowsOrderAndSections', allRowData).catch((error) => {
                console.error('Error saving row order and sections:', error);
            });
        }
    }
});
